import { Codec, string, number, exactly, oneOf, GetInterface } from 'purify-ts';

const Rapport = Codec.interface({
  nedlastLink: string,
  filtype: string,
  navn: string,
  id: number,
});

export type Rapport = GetInterface<typeof Rapport>;

export const ErrorPoll = Codec.interface({
  id: string,
  durationMs: number,
  durationMsString: string,
  status: exactly('ERROR'),
  error: string,
});

export type ErrorPoll = GetInterface<typeof ErrorPoll>;

export const PendingPoll = Codec.interface({
  id: string,
  durationMs: number,
  durationMsString: string,
  status: exactly('PENDING'),
});

export type PendingPoll = GetInterface<typeof PendingPoll>;

export const SuccessPoll = Codec.interface({
  id: string,
  durationMs: number,
  durationMsString: string,
  status: exactly('SUCCESS'),
  rapport: Rapport,
});

export type SuccessPoll = GetInterface<typeof SuccessPoll>;

export const UnknownPoll = Codec.interface({
  id: string,
  status: exactly('UNKNOWN'),
});

export type UnknownPoll = GetInterface<typeof UnknownPoll>;

export const PollData = oneOf([ErrorPoll, PendingPoll, SuccessPoll, UnknownPoll]);

export type PollData = GetInterface<typeof PollData>;
